/**
 * Return Wireless Sales SDK response data.
 * @memberof posPlatform.wireless
 * @function ssdkResponseData
 * @returns {*} Origin response data
 */
export default response => response;